export enum Theme {
	DAY = 'day',
	NIGHT = 'night'
}

export interface Preferences {
	theme?: Theme;
	store?: Record<string, unknown>
}